import { useState } from "react";
import Lightbox from "@/components/ui/lightbox";
import { ProjectType } from "@/data/projects";

interface PhotoGalleryProps {
  projects: ProjectType[];
}

const PhotoGallery = ({ projects }: PhotoGalleryProps) => {
  const [currentImage, setCurrentImage] = useState<number | null>(null);

  const openLightbox = (index: number) => {
    setCurrentImage(index);
  };

  const closeLightbox = () => {
    setCurrentImage(null);
  };

  const goToPrevious = () => {
    setCurrentImage((prevIndex) => 
      prevIndex === 0 ? projects.length - 1 : prevIndex! - 1
    );
  };

  const goToNext = () => {
    setCurrentImage((prevIndex) => 
      prevIndex === projects.length - 1 ? 0 : prevIndex! + 1
    );
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project, index) => (
          <div 
            key={project.id}
            className="gallery-item rounded-lg overflow-hidden shadow-md cursor-pointer"
            onClick={() => openLightbox(index)}
          >
            <img 
              src={project.image} 
              alt={project.title} 
              className="w-full h-64 object-cover"
            />
            <div className="p-4 bg-white">
              <h3 className="text-lg font-heading font-bold text-primary truncate">
                {project.title}
              </h3>
              <p className="text-sm text-gray-600">{project.location}</p>
            </div>
          </div>
        ))}
      </div>

      {currentImage !== null && (
        <Lightbox 
          image={projects[currentImage].image}
          title={projects[currentImage].title}
          location={projects[currentImage].location}
          onClose={closeLightbox}
          onPrevious={goToPrevious}
          onNext={goToNext}
        />
      )}
    </>
  );
};

export default PhotoGallery;
